import { Component, EventEmitter, Input, Output, OnChanges, inject, SimpleChanges } from '@angular/core';
import { Patient } from '../../../core/models/patient.model';
import { Prescriber } from '../../../core/models/prescriber.model';
import { PatientService } from '../../../core/services/patient.service';
import { MinimalProvider } from '../../../core/models/minimal-provider.model';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { PrescriberNameComponent } from '../../../shared/components/prescriber-name/prescriber-name.component';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { PrescriberListComponent } from '../prescriber-list/prescriber-list.component';
import { handleSimpleChanges } from '../../../core/lib/component-utils';

@Component({
  selector: 'app-inbound-fax-select-prescriber',
  templateUrl: './inbound-fax-select-prescriber.component.html',
  styleUrls: ['./inbound-fax-select-prescriber.component.scss'],
  imports: [MatProgressSpinner, PrescriberNameComponent, FaIconComponent, PrescriberListComponent]
})
export class InboundFaxSelectPrescriberComponent implements OnChanges {
  private patientService = inject(PatientService);

  prescribers: Prescriber[] = new Array<Prescriber>();
  refreshing = false;

  @Input() selectedPatient: Patient;
  @Input() selectedProvider: MinimalProvider;

  @Output() public selectionChange = new EventEmitter<Prescriber>();


  ngOnChanges(changes: SimpleChanges) {
    handleSimpleChanges(changes, (inputName: string) => {
      if (inputName === 'selectedPatient') {
        if (this.selectedPatient) {
          this.loadPatientPrescribers();
        } else {
          this.prescribers = new Array<Prescriber>();
        }
      }
    });
  }

  loadPatientPrescribers() {
    this.refreshing = true;

    this.patientService.getPrescribers(this.selectedPatient.id).subscribe((prescribers: Prescriber[]) => {
      this.prescribers = prescribers;
      this.refreshing = false;
    });
  }

  onPrescriberSelect(prescriber: Prescriber) {
    this.selectionChange.emit(prescriber);
  }

  onPrescriberClear() {
    this.selectionChange.emit(null);
  }
}
